package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AgregarPatrullaModal(
    onDismiss: () -> Unit,
    onConfirm: (nombre: String, rut: String, email: String, contrasena: String) -> Unit
) {
    var nombre by remember { mutableStateOf("") }
    var rut by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    
    // --- ¡ORDEN DE PRE-LLENADO! ---
    var contrasena by remember { mutableStateOf("212121") } 

    // Capa de fondo
    Div({
        style {
            position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
            backgroundColor(rgba(0, 0, 0, 0.6))
            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
            property("z-index", "1000")
        }
    }) {
        // Caja de contenido (CON SCROLL Y ALTURA MÁXIMA)
        Div({
            style {
                width(500.px); maxHeight(90.vh); overflowY("auto")
                backgroundColor(Color.white); borderRadius(12.px); padding(32.px)
                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
            }
        }) {
            H2({ style { marginTop(0.px); color(Color("#1976D2")) } }) { Text("Reclutar Nueva Patrulla") }

            // --- SECCIÓN DE DATOS PERSONALES ---
            Label { Text("Datos de la Patrulla:") }
            Input(type = InputType.Text, attrs = {
                value(nombre)
                placeholder("Nombre Completo")
                style { padding(12.px); fontSize(16.px); width(100.percent); boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray); borderRadius(4.px) }
                onInput { event -> nombre = event.value }
            })

            Input(type = InputType.Text, attrs = {
                value(rut)
                placeholder("RUT (ej: 12.345.678-9)")
                style { padding(12.px); fontSize(16.px); width(100.percent); boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray); borderRadius(4.px) }
                onInput { event -> rut = event.value }
            })

            // --- SECCIÓN DE ACCESO (ESTO ES LO QUE SOLICITASTE) ---
            Hr()
            Label { Text("Credenciales de Acceso (App):") }
            Input(type = InputType.Email, attrs = {
                value(email)
                placeholder("Correo Electrónico (Login)")
                style { padding(12.px); fontSize(16.px); width(100.percent); boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray); borderRadius(4.px) }
                onInput { event -> email = event.value }
            })

            Input(type = InputType.Password, attrs = {
                value(contrasena)
                // --- ¡NUEVA INSTRUCCIÓN! ---
                placeholder("Clave Estándar: 212121")
                style { padding(12.px); fontSize(16.px); width(100.percent); boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray); borderRadius(4.px) }
                onInput { event -> contrasena = event.value }
            })

            P({ style { fontSize(12.px); color(Color.gray); marginTop((-10).px) } }) {
                Text("* Se recomienda al patrullero cambiar esta clave en su primer ingreso.")
            }

            // Botones
            Div({
                style { display(DisplayStyle.Flex); justifyContent(JustifyContent.End); gap(16.px); marginTop(16.px) }
            }) {
                Button(attrs = {
                    onClick { onDismiss() }
                    style { padding(12.px, 24.px); backgroundColor(Color("#6c757d")); color(Color.white); border(0.px); borderRadius(8.px); cursor("pointer") }
                }) { Text("Cancelar") }
                Button(attrs = {
                    val canConfirm = nombre.isNotBlank() && rut.isNotBlank() && email.isNotBlank() && contrasena.length >= 6
                    onClick { if (canConfirm) onConfirm(nombre, rut, email, contrasena) }
                    if (!canConfirm) disabled()
                    style { 
                        padding(12.px, 24.px); 
                        backgroundColor(if (canConfirm) Color("#34A853") else Color.lightgray); 
                        color(Color.white); border(0.px); borderRadius(8.px); 
                        cursor(if (canConfirm) "pointer" else "not-allowed") 
                    }
                }) { Text("Crear Patrulla") }
            }
        }
    }
}
